<template>
  <div>
    <CAlert show color="light">
      Conecte a plataforma a serviços externos. Cada integração é independente:
      instale só as que a operação usa e configure-as sem depender de uma nova versão.
    </CAlert>

    <div class="barra-ferramentas">
      <div class="campo-busca">
        <fa-icon icon="search" class="campo-busca__icone" />
        <input
          v-model="busca"
          type="search"
          class="form-control form-control-sm"
          placeholder="Buscar integração..."
        />
      </div>

      <!--
        Em linha própria: são oito categorias, e dividir a linha com a busca faz
        os chips transbordarem por baixo do campo.
      -->
      <div class="categorias">
        <button
          v-for="categoria in categoriasDisponiveis"
          :key="categoria.chave"
          type="button"
          class="categoria"
          :class="{ 'categoria--ativa': categoriaAtiva === categoria.chave }"
          @click="categoriaAtiva = categoria.chave"
        >
          {{ categoria.nome }}
          <span class="categoria__contagem">{{ categoria.total }}</span>
        </button>
      </div>
    </div>

    <div v-if="conectoresFiltrados.length" class="grade-conectores">
      <CardConector
        v-for="conector in conectoresFiltrados"
        :key="conector.slug"
        :conector="conector"
        @instalar="$emit('instalar', conector)"
      />
    </div>

    <EmptyState
      v-else
      icon="search"
      title="Nenhuma integração encontrada"
      description="Tente outro termo de busca ou remova o filtro de categoria."
    />
  </div>
</template>

<script>
import EmptyState from '@/components/EmptyState';
import CardConector from './components/CardConector';

const TODAS = 'TODAS';

export default {
  name: 'Marketplace',
  components: { CardConector, EmptyState },
  props: {
    conectores: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      busca: '',
      categoriaAtiva: TODAS,
    };
  },
  computed: {
    /*
     * As categorias vêm dos conectores realmente disponíveis, não de uma lista
     * fixa: oferecer um filtro que não devolve nada é ruído. A contagem entra no
     * chip para o usuário saber o que esperar antes de clicar.
     */
    categoriasDisponiveis() {
      const contagem = new Map();

      this.conectores.forEach((conector) => {
        const atual = contagem.get(conector.categoria);

        contagem.set(conector.categoria, {
          chave: conector.categoria,
          nome: conector.categoria_nome,
          total: (atual ? atual.total : 0) + 1,
        });
      });

      const categorias = Array.from(contagem.values()).sort((a, b) =>
        a.nome.localeCompare(b.nome, 'pt-BR')
      );

      return [{ chave: TODAS, nome: 'Todas', total: this.conectores.length }, ...categorias];
    },

    conectoresFiltrados() {
      const termo = this.busca.trim().toLowerCase();

      return this.conectores.filter((conector) => {
        if (this.categoriaAtiva !== TODAS && conector.categoria !== this.categoriaAtiva) {
          return false;
        }

        if (!termo) {
          return true;
        }

        const alvo = [conector.nome, conector.descricao_curta, conector.categoria_nome]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        return alvo.includes(termo);
      });
    },
  },
};
</script>

<style scoped>
.barra-ferramentas {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 18px;
}

.campo-busca {
  position: relative;
  width: 100%;
  max-width: 340px;
}

.campo-busca__icone {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #98a2b3;
  font-size: 13px;
  pointer-events: none;
}

.campo-busca input {
  padding-left: 32px;
}

.categorias {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.categoria {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border: 1px solid #e4e7eb;
  border-radius: 16px;
  background: #fff;
  font-size: 12px;
  font-weight: 500;
  color: #475467;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
}

.categoria:hover {
  border-color: #b9b7d1;
}

.categoria--ativa {
  border-color: #3a3e81;
  background: #eceaf3;
  color: #3a3e81;
}

.categoria__contagem {
  font-size: 11px;
  color: #98a2b3;
}

.categoria--ativa .categoria__contagem {
  color: #3a3e81;
}

.grade-conectores {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}
</style>
